var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1868 22.9263L11.6651 17.5947L6.3335 15.073L11.6651 12.5513L14.1868 7.21973L16.7085 12.5513L22.0401 15.073L16.7085 17.5947L14.1868 22.9263Z",
    fill: "#F2C94C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4758 31.7617L23.7421 28.0962L20.0767 26.3625L23.7421 24.6289L25.4758 20.9634L27.2095 24.6289L30.875 26.3625L27.2095 28.0962L25.4758 31.7617Z",
    fill: "#F2C94C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9667 12.1283L25.0211 10.1289L23.0217 9.18327L25.0211 8.23763L25.9667 6.23828L26.9124 8.23763L28.9117 9.18327L26.9124 10.1289L25.9667 12.1283Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStars);
export default __webpack_public_path__ + "static/media/new-stars.37df5808c784435f8a8c0645b357d72b.svg";
export { ForwardRef as ReactComponent };